// extracted by mini-css-extract-plugin
module.exports = {"link":"Links_link__1NWEi","pageLink":"Links_pageLink__3ODH3"};